(() => {
    "use strict";
    const init = (root = document) => {
        root.querySelectorAll("[data-softies-form]").forEach((form) => {
            if (form.dataset.initialized) return;
            form.dataset.initialized = "true";
            const wrapper = form.closest(".softies-club");
            const summary = form.querySelector("[data-error-summary]");
            const button = form.querySelector('[type="submit"]');
            if (!wrapper || !summary || !button) return;
            let attempted = false;
            let submitting = false;
            const fields = [...form.querySelectorAll("[data-validate]")];
            const questions = [...form.querySelectorAll("[data-question]")];

            const error = (group, message) => {
                const node = group.querySelector("[data-error]");
                if (node) {
                    node.textContent = message;
                    node.hidden = !message;
                }
                group.querySelectorAll("input").forEach((input) => input.setAttribute("aria-invalid", message ? "true" : "false"));
            };

            const validate = () => {
                let first = null;
                fields.forEach((input) => {
                    input.value = input.value.trim();
                    let message = "";
                    if (input.required && !input.value) message = `Please enter your ${input.dataset.label}.`;
                    else if (input.value.length > input.maxLength) message = `Please keep your ${input.dataset.label} to ${input.maxLength} characters or fewer.`;
                    else if (input.type === "email" && input.value && !input.validity.valid) message = "Please enter a valid email address.";
                    else if (input.type === "tel" && input.value) {
                        const count = input.value.replace(/\D/g, "").length;
                        if (!/^\+?[0-9 ()-]+$/.test(input.value) || count < 7 || count > 15) message = "Please enter a valid mobile number, or leave it blank.";
                    }
                    const group = input.closest("[data-field]");
                    if (group) error(group, message);
                    if (message && !first) first = input;
                });

                questions.forEach((question) => {
                    const checked = question.querySelector("input:checked");
                    const message = checked ? "" : question.hasAttribute("data-multiple") ? "Please choose at least one option." : "Please choose one answer.";
                    error(question, message);
                    if (message && !first) first = question.querySelector("input");
                });

                summary.textContent = first ? "Please check the highlighted fields before joining the club." : "";
                summary.hidden = !first;
                return first;
            };

            form.noValidate = true;
            form.addEventListener("input", () => {
                if (attempted) validate();
            });
            form.addEventListener("change", () => {
                if (attempted) validate();
            });

            form.addEventListener("submit", (event) => {

                if (submitting) {                    
                    event.preventDefault();
                    return;
                } 
                attempted = true;
                const first = validate();
                if (first) {                    
                    event.preventDefault();
                    first.focus();
                    return;
                }

                const configuredAction = form.getAttribute("action") || "";
                let destination;
                try {
                    destination = new URL(configuredAction);
                } catch {
                    destination = null;
                }
                const ready = form.dataset.dotdigitalReady === "true";

                if (!ready || !destination || destination.protocol !== "https:" || destination.username || destination.password || destination.hostname.endsWith(".invalid") || destination.hostname === "example.com") {
                    event.preventDefault();
                    summary.hidden = false;
                    summary.textContent = "Registration is not available yet. Please try again later.";
                    summary.focus();
                    return;
                }

                submitting = true;
                button.disabled = true;
                button.textContent = "Joining...";
                
                //PUTTING THE INTERESTS INTO ONE FIELD
                const interests = [...form.querySelectorAll('input[name="INTERESTS"]:checked')].map((cb) => cb.value);
                form.querySelector("#INTERESTS").value = interests.join(", ");

            });

            window.addEventListener("pageshow", () => {
                submitting = false;
                button.disabled = false;
                button.textContent = "Join the club";
            });
        });
    };

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init());
    else init();
    document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
